@if (!data.completed) {
  <section class="card route-event {{ data.type }}" [ngClass]="{ 'started': data.started }" data-testid="card">
    <div class="header">
      <div class="icons type">
        @for (icon of data.typeIcons; track icon) {
          @if (icon.svg) {
            <ion-icon
              [class]="icon.type"
              [src]="'assets/icons/' + icon.name + '.svg'"
              [title]="icon.label | translate"
              [attr.data-testid]="icon.label"
              />
          }
          @if (!icon.svg) {
            <ion-icon
              [class]="icon.type"
              [name]="icon.name"
              [title]="icon.label | translate"
              [attr.data-testid]="icon.label"
              />
          }
        }
      </div>
      @if (data.headerInfo.time) {
        <time data-testid="time" [ngClass]="{ 'late': data.isLate }">
          @if (data.isLate) {
            <ion-icon name="alarm-outline" class="late" [attr.alt]="'LABEL.late' | translate" />
          }
          {{ data.headerInfo.time }}
        </time>
      }
      <span data-testid="type" class="title" role="heading" [attr.aria-level]="headerLevel">{{ data.headerInfo.type | translate }}</span>
      @if (data.headerInfo.details) {
        <span data-testid="details" class="details">{{ data.headerInfo.details }}</span>
      }
      @if (data.headerInfo.subtitle) {
        <div data-testid="subtitle" class="subtitle">{{ data.headerInfo.subtitle }}</div>
      }
      @if (data.headerInfo.timeTo) {
        <div data-testid="timeTo" class="time-to">{{ data.headerInfo.timeTo }}</div>
      }
      <div class="details icons-and-badges" data-testid="icons-and-badges">
        @for (icon of data.detailIcons; track icon) {
          @if (icon.svg) {
            <ion-icon
              [class]="icon.type"
              [src]="'assets/icons/' + icon.name + '.svg'"
              [title]="icon.label | translate"
              [attr.data-testid]="icon.label"
              />
          }
          @if (!icon.svg) {
            <ion-icon
              [class]="icon.type"
              [name]="icon.name"
              [title]="icon.label | translate"
              [attr.data-testid]="icon.label"
              />
          }
        }
        @for (badge of data.detailBadges; track badge) {
          <ion-badge
            [color]="badge.color"
            [ngClass]="badge.class"
            [attr.data-testid]="badge.label"
            >
            {{ badge.label | translate }}
          </ion-badge>
        }
      </div>
    </div>
    <div class="content">
      @if (data.location) {
        <app-address
          [location]="data.location"
          [phoneNumber]="data.phoneNumber"
          [rideId]="data?.value?.rideId"
          />
      }
      @if (tapForDetails && data.tapForDetails && !activelyDriving) {
        <button
          type="button"
          (click)="data.tapForDetails()"
          class="tap-for-details"
          data-testid="tapForDetails"
          >
          <ion-icon name="expand" slot="start" aria-hidden="true" />
          {{ 'LABEL.tapForDetails' | translate }}
        </button>
      }
      @if (data.timer && (data.type !== 'break' || features.showBreakTimer)) {
        <div class="timer" [ngClass]="{ 'time-is-up': data.timer === '00:00' }" aria-live="polite">
          <div class="time">{{ data.timer }}</div>
          <div class="label">{{ 'LABEL.timeRemaining' | translate }}</div>
        </div>
      }
    </div>
    <div class="actions">
      @for (action of data.actions; track action) {
        @if (
          (preview ? action.preview : true)
          && (first || !onlyFirst || action.preview)
          && ((activelyDriving && action.drivingMode) || !activelyDriving)
          ) {
          <ion-button
            type="button"
            expand="block"
            [attr.class]="action.type"
            [color]="action.color"
            [fill]="action.fill"
            (click)="action.fn(action)"
            [disabled]="action.disabled"
            [attr.data-testid]="action.label"
            >
            <ion-icon slot="start" [name]="action.icon" aria-hidden="true" />
            {{ action.label | translate }}
          </ion-button>
        }
      }
    </div>
  </section>
}
